import { base } from '../base';
import { base_v2 } from '../base_v2';


async function getReportStocker(param) {
  return base.get('stokers/dashboard/count-summary', param)
}

async function getReportInventory(param) {
  return base.get('reports/inventory', param)
}

async function getReportTrademarkRevenue(param) {
  return base.get('trademarks/dashboard/sales-summary', param)
}

async function getReportTrademarkRevenueDetail(param) {
  return base.get('trademarks/dashboard/sales-detail', param)
}

async function getReportTrademarkInventory(param) {
  return base.get('trademarks/dashboard/inventory-summary', param)
}

async function getReportAccountant(param) {
  return base.get('accountants/dashboard/debt/summary', param)
}

async function getReportDetailAccountant(param) {
  return base.get('accountants/dashboard/debt/details', param)
}

async function getReportStockSummary(param) {
  return base.get('reports/stock/summary', param)
}

async function getReportStockDetail(param) {
  return base.get('reports/stock/details', param)
}

async function getReportCollectPay(param) {
  return base.get('accountants/reports/receipts-expenses/summary', param)
}

async function getReportCollectPayDetail(param) {
  return base.get('accountants/reports/receipts-expenses/details', param)
}

async function getReportCollectPayDetailV2(param) {
  return base_v2.get('accountants/reports/receipts-expenses/details', param)
}

async function getExportForSalesman(param) {
  return base.get('stokers/reports/salesman-provided-items', param)
}

async function getItemNotPrice(param) {
  return base.get('stokers/reports/no-inventory-items', param)
}

async function getItemDonation(param) {
  return base.get('reports/item-donation', param)
}

async function getRevenue(param) {
  return base.get('reports/revenue', param)
}

async function getRevenueByItem(param) {
  return base.get('reports/revenue-by-items/summary', param)
}

async function getRevenueByItemSKU(param) {
  return base.get('reports/revenue-by-items/details', param)
}

async function getReportReturnItem(param) {
  return base.get('reports/customer-return/summary', param)
}

async function getReportShipper(param) {
  return base.get('reports/delivery/details', param)
}

async function getReportReturnItemDetail(param) {
  return base.get('reports/customer-return/details', param)
}

async function getReportDebtCustomer(param) {
  return base.get('reports/debt/customer/summary', param)
}

async function getReportDebtCustomerDetail(param) {
  return base.get('reports/debt/customer/details', param)
}

async function getReportDebtCustomerHistory(param){
  return base.get('reports/debt/customer/history', param)
}

async function getReportDebtSalesman(param) {
  return base.get('reports/debt/salesman/summary', param)
}

async function getReportDebtSalesmanDetail(param) {
  return base.get('reports/debt/salesman/details', param)
}

async function getReportRevenueByBrand(param) {
  return base.get('reports/revenue-by-trademark/summary', param)
}

async function getReportRevenueByBrandDetail(param) {
  return base.get('reports/revenue-by-trademark/details', param)
}

async function getReportGrTrademarkSummary(param) {
  return base.get('reports/gr/trademark/summary', param)
}

async function getReportGrTrademarkDetail(param) {
  return base.get('reports/gr/trademark/details', param)
}

async function getReportSentOtp(param) {
  return base.get('reports/sent-otp', param)
}


async function getReportDailyShipping(param) {
  return base.get('stokers/reports/daily-shipping', param)
}

async function getCountWarehouseCard(params){
  return base.get('reports/stock/card/count', params)
}

async function getWarehouseCard(params){
  return base.get('reports/stock/card', params)
}

async function getCostPrice(params){
  return base.get('reports/price/cost', params)
}

export const reportService = {
  getReportStocker,
  getReportInventory,
  getReportTrademarkRevenue,
  getReportTrademarkRevenueDetail,
  getReportTrademarkInventory,
  getReportAccountant,
  getReportDetailAccountant,
  getReportStockSummary,
  getReportStockDetail,
  getReportCollectPay,
  getReportCollectPayDetail,
  getExportForSalesman,
  getItemNotPrice,
  getItemDonation,
  getRevenue,
  getRevenueByItem,
  getReportShipper,
  getRevenueByItemSKU,
  getReportDebtCustomer,
  getReportDebtCustomerDetail,
  getReportDebtCustomerHistory,
  getReportDebtSalesman,
  getReportDebtSalesmanDetail,
  getReportReturnItem,
  getReportReturnItemDetail,
  getReportRevenueByBrand,
  getReportRevenueByBrandDetail,
  getReportCollectPayDetailV2,
  getReportGrTrademarkSummary,
  getReportGrTrademarkDetail,
  getReportSentOtp,
  getReportDailyShipping,
  getCountWarehouseCard,
  getWarehouseCard,
  getCostPrice
}